export interface ColorStyle {
  id: string;
  label: string;
  description: string;
  prompt: string;
  emoji: string;
  color: string;
}

export const COLOR_STYLES: ColorStyle[] = [
  {
    id: 'realistic',
    label: 'Realistic',
    description: 'Natural, true-to-life colors',
    prompt: 'natural realistic colors, true to life, accurate skin tones and environmental colors',
    emoji: '📸',
    color: 'bg-blue-500',
  },
  {
    id: 'vintage',
    label: 'Vintage',
    description: 'Warm, nostalgic 1950s look',
    prompt: 'warm sepia tones, nostalgic 1950s color palette, slightly faded film look',
    emoji: '🎞️',
    color: 'bg-amber-600',
  },
  {
    id: 'cyberpunk',
    label: 'Cyberpunk',
    description: 'Neon, futuristic vibes',
    prompt: 'neon cyan and magenta, futuristic cyberpunk style, high contrast vibrant night lighting',
    emoji: '🌆',
    color: 'bg-purple-600',
  },
  {
    id: 'pastel',
    label: 'Pastel',
    description: 'Soft, dreamy aesthetic',
    prompt: 'soft pastel colors, dreamy aesthetic, gentle lighting, low saturation',
    emoji: '🎨',
    color: 'bg-pink-400',
  },
  {
    id: 'dramatic',
    label: 'Dramatic',
    description: 'Cinematic, high contrast',
    prompt: 'high contrast, cinematic color grading, moody lighting, deep shadows',
    emoji: '🎭',
    color: 'bg-slate-800',
  },
  {
    id: 'vibrant',
    label: 'Vibrant',
    description: 'Bold and saturated',
    prompt: 'vibrant and saturated colors, bold tones, energetic feel',
    emoji: '🌈',
    color: 'bg-orange-500',
  },
];

export interface ColorizationResult {
  id: string;
  imageUrl: string;
  styleId: string;
  timestamp: number;
}
